module.exports = __webpack_public_path__ + "static/media/01.276b617b.png";